import { Link } from "react-router-dom";

const cardImages = [
  "https://net-basis.net/Bilder/christof-guenther-ict-management-dach.webp",
  "https://net-basis.net/Bilder/netbasis-core-values-trust-partnership.webp",
  "https://net-basis.net/Bilder/netbasis-mission-vision-teamwork-success.webp",
];

interface AboutCardsTexts {
  management_title?: string;
  management_desc?: string;
  core_values_title?: string;
  core_values_desc?: string;
  mission_vision_title?: string;
  mission_vision_desc?: string;
  read_more?: string;
}

interface AboutCardsUrls {
  management?: string;
  core_values?: string;
  mission_vision?: string;
}

export default function AboutCardsSection({ texts, urls }: { texts?: AboutCardsTexts; urls?: AboutCardsUrls }) {

  const cards = [
    {
      id: 1,
      title: texts?.management_title ?? "",
      description: texts?.management_desc ?? "",
      image: cardImages[0],
      href: urls?.management ?? "/de/ueber-uns/management",
    },
    {
      id: 2,
      title: texts?.core_values_title ?? "",
      description: texts?.core_values_desc ?? "",
      image: cardImages[1],
      href: urls?.core_values ?? "/de/ueber-uns/grundwerte",
    },
    {
      id: 3,
      title: texts?.mission_vision_title ?? "",
      description: texts?.mission_vision_desc ?? "",
      image: cardImages[2],
      href: urls?.mission_vision ?? "/de/ueber-uns/mission-vision",
    },
  ];

  const readMore = texts?.read_more ?? "";

  return (
    <section className="py-5 md:py-7 px-4 md:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-3 md:gap-4 items-stretch">
          {cards.map((card) => (
            <div
              key={card.id}
              className="group bg-white rounded-lg overflow-hidden border border-background-200 transition-all duration-300 hover:border-primary-300 flex flex-col h-full"
            >
              {/* Image */}
              <div className="h-40 md:h-48 overflow-hidden w-full flex-shrink-0">
                <img
                  src={card.image}
                  alt={card.title}
                  title={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>

              {/* Content */}
              <div className="p-4 md:p-5 flex flex-col flex-1">
                <h3 className="font-heading text-lg md:text-xl font-bold text-primary-600 mb-2">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-950 leading-relaxed mb-4 line-clamp-4 flex-1">
                  {card.description}
                </p>
                <Link
                  to={card.href}
                  className="inline-flex items-center gap-1 px-4 py-2 font-heading text-sm font-medium text-primary-600 border border-primary-300 rounded-md hover:bg-primary-500 hover:text-white hover:border-primary-500 transition-colors cursor-pointer whitespace-nowrap mt-auto self-start"
                >
                  {readMore}
                  <i className="ri-arrow-right-line text-sm" />
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}